// extracted by mini-css-extract-plugin
module.exports = {"index":"download-wrap_index_2KQH2"};